import { render, staticRenderFns } from "./oAuthPage.vue?vue&type=template&id=396a15a1&scoped=true"
import script from "./oAuthPage.vue?vue&type=script&lang=js"
export * from "./oAuthPage.vue?vue&type=script&lang=js"
import style0 from "./oAuthPage.vue?vue&type=style&index=0&id=396a15a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396a15a1",
  null
  
)

export default component.exports